export const SIGN_IN_OPEN = 'SIGN_IN_OPEN'
export const SIGN_IN_CLOSE = 'SIGN_IN_CLOSE'
export const SIGN_UP_OPEN = 'SIGN_UP_OPEN'
export const SIGN_UP_CLOSE = 'SIGN_UP_CLOSE'
export const ENTER_CONSOLE = 'ENTER_CONSOLE'
export const LEAVE_CONSOLE = 'LEAVE_CONSOLE'
export const AUTH_STATE_CHANGE = 'AUTH_STATE_CHANGE'
